import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCommandType, resetOperation } from "../../../redux/operationSlice";

const ToolScene = ({ scene }) => {
    const [activeCommand, setActiveCommand] = useState(null);
    const dispatch = useDispatch();
    const supply = useSelector((state) => state.simpleSupply);
    const operationHistory = useSelector((state) => state.operationHistory);
    const operation = useSelector((state) => state.operation);

    const handleClick = (command) => {
        if (command === activeCommand) {
            dispatch(resetOperation());
            setActiveCommand(null);
        } else {
            dispatch(setCommandType(command));
            setActiveCommand(command);
        }
    };

    const handleOp = () => {
            
    };

    const handleOpHist = () => {
        
    };

    const handleSupply = () => {
    };

    return (
        <div className="ToolSceneTest">
            <div className="toolRowTest">               
                <button className="toolButtonTest" onClick={handleOp}>
                    Oper.
                </button>
                <button className="toolButtonTest" onClick={handleOpHist}>
                    OP.His.
                </button>
                <button className="toolButtonTest" onClick={handleSupply}>
                    SUPPLY
                </button>
            </div>
            <div className="modifyTextTest">
                <span>  TESTER</span>
            </div>
        </div>
    );
};

export default ToolScene;
